import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  updateDataEvent: EventEmitter<any> = new EventEmitter();
  downloadExcelEvent: EventEmitter<any> = new EventEmitter();
  uploadExcelEvent: EventEmitter<any> = new EventEmitter();
  tableDataEvent: EventEmitter<any> = new EventEmitter();
  modifyTableEvent: EventEmitter<any> = new EventEmitter();
  reloadTableEvent: EventEmitter<any> = new EventEmitter();
  userRoleEvent: EventEmitter<any> = new EventEmitter();
  authStateEvent: EventEmitter<any> = new EventEmitter();
  userLoginEvent: EventEmitter<any> = new EventEmitter();
  userLogoutEvent: EventEmitter<any> = new EventEmitter();
  newRecordEvent: EventEmitter<any> = new EventEmitter();
  updatedSettingsEvent: EventEmitter<any> = new EventEmitter();
  updatedTableEvent: EventEmitter<any> = new EventEmitter();
  selectionChangeEvent: EventEmitter<any> = new EventEmitter();
  errorFormEvent: EventEmitter<any> = new EventEmitter();

  constructor() { }

  emitRowUpdate(data) {
    this.updateDataEvent.emit(data);
  }

  sendEmittedRowUpdate() {
    return this.updateDataEvent;
  }

  emituploadExcel(data) {
    this.uploadExcelEvent.emit(data);
  }

  getUploadExcelEvent() {
    return this.uploadExcelEvent;
  }

  emitModifyTable(data) {
    this.modifyTableEvent.emit(data);
  }

  getModifyTable() {
    return this.modifyTableEvent;
  }

  emitReloadTable(data) {
    this.reloadTableEvent.emit(data);
  }

  getReloadTable() {
    return this.reloadTableEvent;
  }
  // emitUserRole(),getUsersRole(): Not used still need to change event publish as its deprecated
  emitAuthState(data) {
    this.authStateEvent.emit(data);
  }

  getAuthState() {
    return this.authStateEvent;
  }

  emitUserRole(data) {
    this.userRoleEvent.emit(data);
  }

  getUsersRole() {
    return this.userRoleEvent;
  }

  emitUserLogin(data) {
    this.userLoginEvent.emit(data);
  }

  getUserLogin() {
    return this.userLoginEvent;
  }

  emitUserLogout(data) {
    this.userLogoutEvent.emit(data);
  }

  getUserLogout() {
    return this.userLogoutEvent;
  }

  emitNewRecord(data) {
    this.newRecordEvent.emit(data);
  }

  getNewRecord() {
    return this.newRecordEvent;
  }

  emitUpdatedSettings(data) {
    this.updatedSettingsEvent.emit(data);
  }

  getUpdatedSettings() {
    return this.updatedSettingsEvent;
  }

  emitUpdatedTableEvent(data) {
    this.updatedTableEvent.emit(data);
  }

  getUpdatedTableEvent() {
    return this.updatedTableEvent;
  }
  
  emitselectionChangeEvent(data) {
    this.selectionChangeEvent.emit(data);
  }

  getselectionChangeEvent() {
    return this.selectionChangeEvent;
  }

  emitErrorFormEvent(data){
    this.errorFormEvent.emit(data);
  }

  getErrorFormEvent(){
    return this.errorFormEvent;
  }
}
